import React from 'react';
const rows = [{
  before: 'Sunday nights spent scrolling Instagram for "inspiration."',
  after: '–90% time. Professional plans ready on your iPad in 2 clicks.',
  labelBefore: 'Planning',
  labelAfter: 'Planning'
}, {
  before: 'Doubts when managing clients with lower back pain or injuries.',
  after: 'Total authority. Safe, biomechanically-sound protocols.',
  labelBefore: 'Confidence',
  labelAfter: 'Confidence'
}, {
  before: 'Stagnant classes that bore your long-term studio members.',
  after: '100% fresh. Logical progressions that keep them coming back.',
  labelBefore: 'Variety',
  labelAfter: 'Variety'
}, {
  before: 'Arriving at the studio mentally exhausted from over-thinking.',
  after: 'Zero stress. Arrive energised to actually connect with your class.',
  labelBefore: 'Burnout',
  labelAfter: 'Burnout'
}];
export function ContrastSection() {
  return <section className="w-full bg-bg-dark py-20 px-4" data-id="element-49">
      <div className="max-w-5xl mx-auto" data-id="element-50">
        <div className="text-center mb-12" data-id="element-51">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main mb-6 tracking-tight" data-id="element-52">
            The Transformation
          </h2>
          <p className="text-text-sec text-lg sm:text-xl max-w-2xl mx-auto" data-id="element-53">
            From a burnt-out instructor to a high-performance professional.
            Here's what changes from your very first Monday morning with The
            Pilates Pack.
          </p>
        </div>

        {/* Time cost callout */}
        <div className="bg-white border border-border-light rounded-2xl p-6 sm:p-8 mb-12 text-center shadow-[0_4px_20px_rgba(201,137,155,0.05)]" data-id="element-54">
          <p className="text-text-main text-lg sm:text-2xl font-bold leading-relaxed" data-id="element-55">
            <span className="text-badge-red font-black block mb-2" data-id="element-56">
              150+ HOURS SAVED PER YEAR
            </span>
            The real cost: planning manually takes up to 5 hours a week. That's
            an entire working month every year wasted on notebooks, messy
            sketches, and creative blocks.
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-[0_8px_30px_rgba(201,137,155,0.08)] border border-border-light overflow-hidden" data-id="element-57">
          {/* Header */}
          <div className="grid grid-cols-1 md:grid-cols-2 border-b border-border-light bg-bg-main" data-id="element-58">
            <div className="px-6 py-5 font-bold text-badge-red text-center md:text-left border-b md:border-b-0 md:border-r border-border-light tracking-wider text-sm" data-id="element-59">
              WITHOUT THE PACK (Your current routine)
            </div>
            <div className="px-6 py-5 font-black text-primary text-center md:text-left tracking-wider text-sm" data-id="element-60">
              WITH THE PILATES PACK (The EduLabs way)
            </div>
          </div>

          {/* Rows */}
          <div className="divide-y divide-border-light" data-id="element-61">
            {rows.map((row, i) => <div key={i} className="grid grid-cols-1 md:grid-cols-2 group hover:bg-bg-main/50 transition-colors" data-id="element-62">
                <div className="px-6 py-6 flex items-start gap-4 border-b md:border-b-0 md:border-r border-border-light bg-badge-red/5" data-id="element-63">
                  <div className="w-6 h-6 rounded-full bg-badge-red/10 flex items-center justify-center flex-shrink-0 mt-0.5 border border-badge-red/20" data-id="element-64">
                    <span className="text-badge-red font-bold text-sm" data-id="element-65">✕</span>
                  </div>
                  <p className="text-text-sec font-medium" data-id="element-66">
                    <strong className="text-badge-red block mb-1" data-id="element-67">
                      {row.labelBefore}:
                    </strong>
                    {row.before}
                  </p>
                </div>
                <div className="px-6 py-6 flex items-start gap-4 bg-primary/5 relative overflow-hidden" data-id="element-68">
                  <div className="absolute inset-0 bg-gradient-to-r from-primary/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-69"></div>
                  <div className="w-6 h-6 rounded-full bg-check-green/10 flex items-center justify-center flex-shrink-0 mt-0.5 border border-check-green/20 relative z-10" data-id="element-70">
                    <span className="text-check-green font-bold text-sm" data-id="element-71">
                      ✓
                    </span>
                  </div>
                  <p className="text-text-main font-medium relative z-10" data-id="element-72">
                    <strong className="text-primary block mb-1" data-id="element-73">
                      {row.labelAfter}:
                    </strong>
                    {row.after}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}